import {getBaseURL} from "@/utils/env";

export default class MenuItemRepository {
  constructor(api) {
    this.api = api
  }

  getAllMenuItems(cityId, userid) {
    const url = `${getBaseURL()}portals/${cityId}/${userid}`

    return this.api.get(url)
  }
}

